import './styles.ts';
let initialized = false;
let modalState = false;
let mediaRecorder: MediaRecorder | null = null;
let recordedChunks: Blob[] = [];
let videoBlob: Blob | null = null;

declare global {
  interface MediaDevices {
    getDisplayMedia(constraints?: MediaStreamConstraints): Promise<MediaStream>;
  }
}

export const initSupaFeedback = (token: string) => {
  if (initialized) {
    return;
  }

  // add a div to the body
  let div = document.getElementById('supafeedback');
  if (!div) {
    div = document.createElement('div');
    div.id = 'supafeedback';
    div.className = 'supafeedback-btn supafeedback-btn-main';
  }
  div.innerHTML = 'Report a bug';

  div.onclick = () => {
    if (!modalState) {
      openModal(token);
    }
  };

  if (!document.getElementById('supafeedback')) {
    document.body.appendChild(div);
  }

  initialized = true;
};

const openModal = (accessToken: string) => {
  modalState = true;
  let modal = document.getElementById('supafeedback-modal');

  if (modal) {
    modal.style.display = 'block';
    return;
  }

  modal = document.createElement('div');
  modal.id = 'supafeedback-modal';
  modal.onclick = e => {
    closeModal();
    e.stopPropagation();
  };

  const content = document.createElement('div');
  content.className = 'supafeedback-content';

  content.onclick = e => {
    e.stopPropagation();
  };

  const close = document.createElement('div');
  close.innerHTML = 'X';
  close.className = 'supafeedback-close';
  close.onclick = () => {
    closeModal();
  };

  const title = document.createElement('h1');
  title.className = 'supafeedback-title';
  title.innerHTML = 'Report a bug';

  const form = document.createElement('form');
  form.className = 'supafeedback-form';
  form.onsubmit = async e => {
    e.preventDefault();

    // disable submit button and change text
    const submit = document.querySelector('#supafeedback-submit');
    if (submit) {
      submit.setAttribute('disabled', 'true');
      submit.innerHTML = 'Uploading...';
    }

    if (!videoBlob) {
      console.error('No video recorded');
      return;
    }

    const formData = new FormData();
    formData.append('file', videoBlob, 'bug_report.webm');
    formData.append(
      'description',
      (document.querySelector('textarea') as HTMLTextAreaElement).value
    );

    try {
      const response = await fetch(
        'https://zb5qarphvg.execute-api.ap-south-1.amazonaws.com/SFB/upload',
        {
          method: 'POST',
          body: formData,
          headers: {
            'x-access-token': accessToken,
          },
        }
      );
      if (response.ok) {
        console.log('Video uploaded successfully');
        closeModal();
        form.reset();
        videoBlob = null;
        // Reset the recorded chunks
        recordedChunks = [];

        //change the button text
        if (submit) {
          submit.removeAttribute('disabled');
          submit.innerHTML = 'Submit';
        }
      } else {
        console.error('Video upload failed');
        //change the button text
        if (submit) {
          submit.removeAttribute('disabled');
          submit.innerHTML = 'Submit';
        }
      }
    } catch (error) {
      console.error('Error uploading video:', error);
      //change the button text
      if (submit) {
        submit.removeAttribute('disabled');
        submit.innerHTML = 'Error Submitting, Please submit again';
      }
    }
  };

  const input = document.createElement('textarea');
  input.name = 'description';
  input.rows = 6;
  input.placeholder = 'Enter your bug report';
  input.required = true;
  input.className = 'supafeedback-input';

  const helpText = document.createElement('p');
  helpText.innerHTML = 'Record a video of the bug and describe it above';

  const recordScreen = document.createElement('button');
  recordScreen.id = 'supafeedback-record-screen';
  recordScreen.type = 'button';
  recordScreen.innerHTML = videoBlob ? 'Re-record' : 'Record screen';
  recordScreen.className = 'supafeedback-btn';
  recordScreen.onclick = () => {
    closeModal();
    startScreenRecording(accessToken);
    console.log('Recording screen');
  };

  const submit = document.createElement('button');
  submit.id = 'supafeedback-submit';
  submit.type = 'submit';
  submit.innerHTML = 'Submit';
  submit.className = 'supafeedback-btn';

  const videoContainer = document.createElement('div');
  videoContainer.id = 'video-container';
  videoContainer.style.display = 'none'; // Hidden initially

  const videoElement = document.createElement('video');
  videoElement.id = 'recorded-video';
  videoElement.controls = true;
  videoElement.style.width = '100%';
  videoElement.style.height = 'auto';

  videoContainer.appendChild(videoElement);

  form.appendChild(input);
  form.appendChild(helpText);
  form.appendChild(videoContainer);
  form.appendChild(recordScreen);
  form.appendChild(submit);
  content.appendChild(close);
  content.appendChild(title);
  content.appendChild(form);

  modal.appendChild(content);
  document.body.appendChild(modal);
};

const closeModal = () => {
  const modal = document.getElementById('supafeedback-modal');
  if (modal) {
    modalState = false;
    modal.style.display = 'none';
    // remove the video container
    const videoContainer = document.getElementById('video-container');
    if (videoContainer) {
      videoContainer.style.display = 'none'; // Hide video container
      videoBlob = null;
      recordedChunks = [];

      //change the button text
      const recordScreen = document.querySelector(
        '#supafeedback-record-screen'
      );
      if (recordScreen) {
        recordScreen.innerHTML = 'Record screen';
      }
    }
  }
};

const startScreenRecording = async (accessToken: string) => {
  try {
    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
    });
    mediaRecorder = new MediaRecorder(stream);

    //Change the button text to count down
    const mainButton = document.querySelector('#supafeedback');

    if (mainButton) {
      mainButton.innerHTML = 'Recording will stop in 10';
    }

    let count = 9;

    const interval = setInterval(() => {
      if (count > 0) {
        if (mainButton) {
          mainButton.innerHTML = `Recording will stop in ${count.toString()}`;
        }
        count--;
      } else {
        clearInterval(interval);
        if (mainButton) {
          mainButton.innerHTML = 'Report a bug';
        }
      }
    }, 1000);

    mediaRecorder.ondataavailable = event => {
      if (event.data.size > 0) {
        recordedChunks.push(event.data);
      }
    };

    mediaRecorder.onstop = async () => {
      clearInterval(interval);
      if (mainButton) {
        mainButton.innerHTML = 'Report a bug';
      }
      stream.getTracks().forEach(track => track.stop());

      openModal(accessToken);
      const blob = new Blob(recordedChunks, { type: 'video/webm' });
      const url = URL.createObjectURL(blob);

      // Display the recorded video
      const videoElement = document.getElementById(
        'recorded-video'
      ) as HTMLVideoElement;
      if (videoElement) {
        videoElement.src = url;
        const videoContainer = document.getElementById('video-container');
        if (videoContainer) {
          videoContainer.style.display = 'block'; // Show video container
        }
      }

      //change the button text
      const recordScreen = document.querySelector(
        '#supafeedback-record-screen'
      );
      if (recordScreen) {
        recordScreen.innerHTML = 'Re-record';
      }

      // Save the video blob
      videoBlob = blob;
      console.log('Video blob:', videoBlob);
    };

    mediaRecorder.start();
    setTimeout(() => {
      mediaRecorder?.stop();
    }, 10000); // Record for 10 seconds
  } catch (err) {
    console.error('Error: ' + err);
  }
};
